import { create } from 'zustand'
import {TABLE_MODES} from "../utils/garrison-timeline-utils.js";
export const useGarrisonTimelineGridStore = create((set,get) => ({
  gridApi: null,
  setGridApi: gridApi => set({ gridApi: gridApi }),

  selectionMode: TABLE_MODES.SELECT_ITEMS,
  setSelectionMode: mode => {
    set({ selectionMode: mode });
  },

  activeMarkerKey: null,
  setActiveMarkerKey: key => set({ activeMarkerKey: key }),

  activeClusterInfo: null,
  setActiveClusterInfo: info => set({ activeClusterInfo: info }),

  selectedItems: [],

  handleRowSelection: (id, isSelected) => {
    const { gridApi, selectedItems } = get();
    let newQueue = [...selectedItems];

    if(isSelected){
      if(!newQueue.includes(id)){
        newQueue.push(id);
      }

      if(newQueue.length > 2){
        const oldestId = newQueue.shift();

        if(gridApi){
          const oldestNode = gridApi.getRowNode(oldestId);
          if(oldestNode && oldestNode.isSelected()){
            oldestNode.setSelected(false);
          }
        }
      }
    } else {
      newQueue = newQueue.filter((itemId) => itemId !== id);
    }

    set({ selectedItems: newQueue });
  },

  clearGridStore: () => {
    set({ gridApi: null });
    set({ selectionMode: TABLE_MODES.SELECT_ITEMS });
    set({ activeMarkerKey: null });
    set({ activeClusterInfo: null });
    set({ selectedItems: [] });
  }
}));